import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigService } from '../../services/config';
import { UrlHelperService } from '../../services/url-helper';
import { ShareButtonComponent } from '../share-button/share-button';

@Component({
  selector: 'app-stock-footer',
  standalone: true,
  imports: [CommonModule, ShareButtonComponent],
  templateUrl: './stock-footer.html',
  styleUrls: ['./stock-footer.scss']
})
export class StockFooterComponent implements OnInit {
  @Input() cid: number = 34;
  alphabet: string[] = [];
  currentYear: number = new Date().getFullYear();

  constructor(
    public config: ConfigService,
    public urlHelper: UrlHelperService
  ) {}

  ngOnInit(): void {
    this.alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  }
}
